import React from "react";
import { useParams } from "react-router-dom"
import { PDFPreview } from "../../../components/PDF";
import PageHero from "../../../components/PageHero";
import NotFound from "../../NotFound";

export default function ProductionDetails({ siteContent }) {
  const { productions } = siteContent

  const { id } = useParams()

  const item = productions.find(i => i.id === id)
  if (!item) return <NotFound />

  const { cover, name, published, title, organizersOrAuthorsOrEvent, description, nameFile, type } = item

  const date = published.split("-").reverse().join("-")

  const renderName = () => {
    if (type === "anaisDeEvento") {
      return "Evento:"
    }
    if (type === "livro") {
      return "Organizador(es):"
    }
    return "Autores:"
  }

  const isMobile = () => {
    return window.matchMedia("(max-width: 768px)").matches
  }

  return (
    <>
      <PageHero
        title={name}
        subtitle={description}
        img={cover?.url}
      />
      <main className="container main">
        <article className="read">
          <h2 className="read__title">{title}</h2>
          <div className="read__meta">
            <span>{date}</span>
          </div>
          <div className="read__meta">
            <span>{renderName()}</span>
            <span>{organizersOrAuthorsOrEvent}</span>
          </div>
          <div className="library-detail">
            <PDFPreview data={{ pdf: nameFile, mobile: isMobile() }} />
          </div>
          <div className="read__actions">
            {isMobile() && (
              <button className="btn btn--primary" onClick={() => window.open(nameFile, "_blank")}>
                IMPRIMIR
              </button>
            )}
            <button className="btn btn--primary" onClick={() => window.close()}>
              FECHAR
            </button>
          </div>
        </article>

      </main>
    </>
  )
}